import React, { useEffect } from 'react';

import { useCookieConsent } from '../hooks/useCookieConsent';
import { initMetaPixel } from '../utils/metaPixel';

/** W3.1 — load Meta Pixel only after marketing cookie consent. */
const MetaPixelLoader: React.FC = () => {
  const { consentState } = useCookieConsent();

  useEffect(() => {
    if (consentState.hasInteracted && consentState.marketing) {
      initMetaPixel();
    }
  }, [consentState.hasInteracted, consentState.marketing]);

  return null;
};

export default MetaPixelLoader;
